export function validateSignals(value) {
  if (!Array.isArray(value) || value.length > 100) throw new Error("invalidSignals");
  const seen = new Set();
  return value.map(signal => {
    if (!signal || typeof signal.name !== "string" || !signal.name.trim() || typeof signal.source !== "string") throw new Error("invalidSignals");
    const key = String(signal.key || "").trim();
    if (key && (!/^[a-zA-Z0-9_-]+$/.test(key) || seen.has(key))) throw new Error("invalidSignals");
    if (key) seen.add(key);
    return { ...signal, ...(key ? { key } : {}), name: signal.name.trim() };
  });
}
export function signalsFromSample(sample) {
  const payload = sample?.payload || sample;
  const measures = payload?.measurements || payload;
  if (!measures || typeof measures !== "object" || Array.isArray(measures)) throw new Error("invalidSignals");
  const rows = Object.entries(measures).flatMap(([key, data]) => {
    if (!/^[a-zA-Z0-9_-]+$/.test(key)) return [];
    const value = data && typeof data === "object" ? data.value : data;
    if (typeof value !== "number" || !Number.isFinite(value)) return [];
    return [{ key, name: key, source: `${payload.measurements ? "measurements." : ""}${key}${data && typeof data === "object" ? ".value" : ""}`, unit: typeof data?.unit === "string" ? data.unit : "" }];
  });
  if (!rows.length || rows.length > 100) throw new Error("invalidSignals");
  return rows;
}
export function mergeSignals(existing, incoming) {
  const keys = new Set(existing.map(s => s.key));
  return [...existing, ...incoming.filter(s => !keys.has(s.key))];
}
